const AD_UNLOCKS_KEY = 'adUnlockedLessons';

/**
 * Returns all lesson IDs the user has unlocked by watching an ad.
 * Stored in localStorage for immediate use without DB setup.
 */
export function getAdUnlockedLessonIds(): string[] {
  try {
    const raw = localStorage.getItem(AD_UNLOCKS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

/**
 * Returns true if a lesson has been unlocked by watching an ad.
 */
export function isLessonAdUnlocked(lessonId: string): boolean {
  return getAdUnlockedLessonIds().includes(lessonId);
}

/**
 * Marks a lesson as unlocked via ad. Persists in localStorage.
 */
export function unlockLessonByAd(lessonId: string): void {
  const existing = getAdUnlockedLessonIds();
  if (!existing.includes(lessonId)) {
    localStorage.setItem(AD_UNLOCKS_KEY, JSON.stringify([...existing, lessonId]));
  }
}
